var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBongdanetShirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_42113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2L9.75 0.75C9.22177 1.06992 8.61751 1.24256 8 1.25C7.38249 1.24256 6.77823 1.06992 6.25 0.75L2.75 2C2.75 2 0.75 3 0.75 6.25V7.25H3.5V14.75C3.5 14.8826 3.55268 15.0098 3.64645 15.1036C3.74021 15.1973 3.86739 15.25 4 15.25H12C12.1326 15.25 12.2598 15.1973 12.3536 15.1036C12.4473 15.0098 12.5 14.8826 12.5 14.75V7.25H15.25V6.25C15.25 3 13.25 2 13.25 2Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2L9.75 0.75C9.51545 0.894349 9.26354 1.00838 9.00031 1.08938L12.25 2.25C12.25 2.25 14.25 3.25 14.25 6.5V7.25H15.25V6.25C15.25 3 13.25 2 13.25 2Z",
    fill: "#D32F2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 2C13.25 2 12.5 3 12.5 5.75V14.75C12.4996 14.8825 12.4468 15.0094 12.3531 15.1031C12.2594 15.1968 12.1325 15.2496 12 15.25H4C3.86751 15.2496 3.74056 15.1968 3.64688 15.1031C3.55319 15.0094 3.50039 14.8825 3.5 14.75V5.75C3.5 3 2.75 2 2.75 2L6.25 0.75C6.77823 1.06992 7.38249 1.24256 8 1.25C8.61751 1.24256 9.22177 1.06992 9.75 0.75L13.25 2Z",
    fill: "#EF5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.75C9.51545 0.894349 9.26354 1.00838 9.00031 1.08938L12.25 2.25C12.4913 2.38736 12.7114 2.55903 12.9035 2.75962C12.9828 2.49144 13.0995 2.23574 13.25 2L9.75 0.75Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.75V14.75C12.4996 14.8825 12.4468 15.0094 12.3531 15.1031C12.2594 15.1968 12.1325 15.2496 12 15.25H4C3.86751 15.2496 3.74056 15.1968 3.64688 15.1031C3.55319 15.0094 3.50039 14.8825 3.5 14.75V14C3.50039 14.1325 3.55319 14.2594 3.64688 14.3531C3.74056 14.4468 3.86751 14.4996 4 14.5H10.5C10.765 14.4992 11.0189 14.3936 11.2062 14.2062C11.3936 14.0189 11.4992 13.765 11.5 13.5V7.75C11.5 7.48478 11.6054 7.23043 11.7929 7.04289C11.9804 6.85536 12.2348 6.75 12.5 6.75Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6.25H3.5V7.25H0.75V6.25Z",
    fill: "#81C784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25H15.25V7.25H12.5V6.25Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25H15.25V7.25H12.5V6.25Z",
    fill: "#81C784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.25C14.25 6.38261 14.1973 6.50979 14.1036 6.60355C14.0098 6.69732 13.8826 6.75 13.75 6.75H12.5V7.25H15.25V6.25H14.25Z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 0.75C6.25 0.75 6.25 2 8 2.75C9.75 2 9.75 0.75 9.75 0.75C9.22177 1.06992 8.61751 1.24256 8 1.25C7.38249 1.24256 6.77823 1.06992 6.25 0.75Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.25H11V9.25H5V7.25Z",
    fill: "#FFB74D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.25V7.5C9.75 7.76522 9.64464 8.01957 9.45711 8.20711C9.26957 8.39464 9.01522 8.5 8.75 8.5H5V9.25H11V7.25H9.75Z",
    fill: "#FFA726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 6.25C10.25 6.25 11 6 11 5.25V4.75H9.5V5.25C9.5 6 10.25 6.25 10.25 6.25Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4.75V5.25C10.2508 5.40013 10.2175 5.54849 10.1525 5.68384C10.0876 5.81919 9.99265 5.93799 9.875 6.03125C9.98679 6.12476 10.1136 6.19872 10.25 6.25C10.25 6.25 11 6 11 5.25V4.75H10.25Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.715 1.095C10.5825 1.8525 9.98747 2.9875 8.39497 3.67L7.99997 3.8375L7.60497 3.67C6.01247 2.9875 5.41747 1.8525 5.28497 1.095L6.24997 0.75C6.24997 0.75 6.24997 2 7.99997 2.75C9.74997 2 9.74997 0.75 9.74997 0.75L10.715 1.095Z",
    fill: "#81C784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60919 1.30685L10.5521 1.64363C10.6259 1.4671 10.6805 1.28317 10.715 1.095L9.74999 0.75C9.7378 0.942711 9.69006 1.1315 9.60919 1.30685Z",
    fill: "#66BB6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_42113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBongdanetShirt);
export default __webpack_public_path__ + "static/media/bongdanet_shirt.0b83b14602e8091bbacdf737d7dbeb68.svg";
export { ForwardRef as ReactComponent };